import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface SubmitQuoteApiParameter extends ApiParameter {
    SubmitQuoteForm: Partial<SubmitQuoteFormModel>;
}

export interface SubmitQuoteFormModel {
    Name:string;
    PhoneNumber:string;
    Email:string;
    CompanyName:string;
    Cart: Root;
}

export interface Root {
    uri: string
    cartLinesUri: string
    id: string
    trackId: string
    status: string
    statusDisplay: string
    type: string
    typeDisplay: string
    orderNumber: string
    erpOrderNumber: string
    orderDate: string
    billTo: any
    shipTo: any
    userLabel: string
    userRoles: any
    shipToLabel: any
    notes: string
    carrier: Carrier
    shipVia: any
    fulfillmentMethod: string
    requestedPickupDate: any
    poNumber: string
    promotionCode: any
    initiatedByUserName: string
    totalQtyOrdered: number
    lineCount: number
    totalCountDisplay: number
    quoteRequiredCount: number
    orderSubTotal: number
    orderSubTotalDisplay: string
    orderSubTotalWithOutProductDiscounts: number
    orderSubTotalWithOutProductDiscountsDisplay: string
    totalTax: number
    totalTaxDisplay: string
    shippingAndHandling: number
    shippingAndHandlingDisplay: string
    orderGrandTotal: number
    orderGrandTotalDisplay: string
    costCodeLabel: any
    isAuthenticated: boolean
    isGuestOrder: boolean
    isSalesperson: boolean
    isSubscribed: boolean
    requiresPoNumber: boolean
    displayContinueShoppingLink: boolean
    canModifyOrder: boolean
    canSaveOrder: boolean
    canBypassCheckoutAddress: boolean
    canRequisition: boolean
    canRequestQuote: boolean
    canEditCostCode: boolean
    showTaxAndShipping: boolean
    showLineNotes: boolean
    showCostCode: boolean
    showNewsletterSignup: boolean
    showPoNumber: boolean
    showCreditCard: boolean
    showECheck: boolean
    showPayPal: boolean
    isAwaitingApproval: boolean
    requiresApproval: boolean
    approverReason: string
    hasApprover: boolean
    salespersonName: string
    costCodes: any[]
    warehouses: any[]
    customerOrderTaxes: any[]
    canCheckOut: boolean
    hasInsufficientInventory: boolean
    currencySymbol: string
    requestedDeliveryDate: any
    requestedDeliveryDateDisplay: any
    cartNotPriced: boolean
    messages: any[]
    creditCardBillingAddress: any
    alsoPurchasedProducts: any[]
    requestedPickupDateDisplay: any
    taxFailureReason: string
    failedToGetRealTimeInventory: boolean
    unassignCart: boolean
    customerVatNumber: string
    vmiLocationId: any
    additionalEmails: string
    defaultWarehouse: DefaultWarehouse
    properties: Properties2
    paymentMethod: any
    paymentOptions: any
    carriers: Carrier2[]
    cartLines: CartLine[]
}

export interface Carrier {
    id: any
    description: any
    shipVias: any[]
}

export interface DefaultWarehouse {
    uri: any
    id: string
    name: string
    address1: string
    address2: string
    city: string
    contactName: string
    countryId: any
    deactivateOn: any
    description: string
    phone: string
    postalCode: string
    shipSite: string
    state: string
    isDefault: boolean
    alternateWarehouses: any
    latitude: number
    longitude: number
    hours: string
    distance: number
    allowPickup: boolean
    pickupShipViaId: any
    properties: Properties
}

export interface Properties {}

export interface Properties2 {}

export interface Carrier2 {
    id: string
    description: string
    shipVias: ShipVia[]
}

export interface ShipVia {
    id: string
    description: string
    isDefault: boolean
}

export interface CartLine {
    uri: string
    productUri: string
    id: string
    line: number
    productId: string
    requisitionId: any
    smallImagePath: string
    altText: string
    productName: string
    manufacturerItem: string
    customerName: any
    shortDescription: string
    erpNumber: string
    unitOfMeasure: string
    unitOfMeasureDisplay: string
    unitOfMeasureDescription: string
    baseUnitOfMeasure: string
    baseUnitOfMeasureDisplay: string
    qtyPerBaseUnitOfMeasure: number
    costCode: string
    notes: string
    qtyOrdered: number
    qtyLeft: number
    pricing: Pricing
    isPromotionItem: boolean
    isDiscounted: boolean
    isConfigured: boolean
    isFixedConfiguration: boolean
    quoteRequired: boolean
    breakPrices: any[]
    sectionOptions: any[]
    availability: Availability
    qtyOnHand: number
    canAddToCart: boolean
    isQtyAdjusted: boolean
    hasInsufficientInventory: boolean
    canBackOrder: boolean
    trackInventory: boolean
    salePriceLabel: string
    cantBuy: boolean
    isSubscription: boolean
    productSubscription: ProductSubscription
    isRestricted: boolean
    canAddToWishlist: boolean
    isActive: boolean
    brand: any
    vmiBinId: any
    isDiscontinued: boolean
    allowZeroPricing: boolean
    properties: Properties3
}

export interface Pricing {
    productId: string
    isOnSale: boolean
    requiresRealTimePrice: boolean
    additionalResults: AdditionalResults
    unitCost: number
    unitCostDisplay: string
    unitListPrice: number
    unitListPriceDisplay: string
    extendedUnitListPrice: number
    extendedUnitListPriceDisplay: string
    unitRegularPrice: number
    unitRegularPriceDisplay: string
    extendedUnitRegularPrice: number
    extendedUnitRegularPriceDisplay: string
    unitNetPrice: number
    unitNetPriceDisplay: string
    extendedUnitNetPrice: number
    extendedUnitNetPriceDisplay: string
    unitOfMeasure: any
    vatRate: number
    vatAmount: number
    vatAmountDisplay: any
    unitListBreakPrices: any[]
    unitRegularBreakPrices: any[]
    regularPrice: number
    regularPriceDisplay: string
    extendedRegularPrice: number
    extendedRegularPriceDisplay: string
    actualPrice: number
    actualPriceDisplay: string
    extendedActualPrice: number
    extendedActualPriceDisplay: string
    regularBreakPrices: any[]
    actualBreakPrices: any[]
    unitListPriceWithVat: number
    unitListPriceWithVatDisplay: any
    extendedUnitListPriceWithVat: number
    extendedUnitListPriceWithVatDisplay: any
    unitRegularPriceWithVat: number
    unitRegularPriceWithVatDisplay: string
    extendedUnitRegularPriceWithVat: number
    extendedUnitRegularPriceWithVatDisplay: string
    vatMinusExtendedUnitRegularPrice: number
}

export interface AdditionalResults {}

export interface Availability {
  messageType: number
  message: any
  requiresRealTimeInventory: boolean
}

export interface ProductSubscription {
    subscriptionAddToInitialOrder: boolean
    subscriptionAllMonths: boolean
    subscriptionApril: boolean
    subscriptionAugust: boolean
    subscriptionCyclePeriod: string
    subscriptionDecember: boolean
    subscriptionFebruary: boolean
    subscriptionFixedPrice: boolean
    subscriptionJanuary: boolean
    subscriptionJuly: boolean
    subscriptionJune: boolean
    subscriptionMarch: boolean
    subscriptionMay: boolean
    subscriptionNovember: boolean
    subscriptionOctober: boolean
    subscriptionPeriodsPerCycle: number
    subscriptionSeptember: boolean
    subscriptionShipViaId: any
    subscriptionTotalCycles: number
}
  
export interface Properties3 {}

const customUrl = "/api/v2/submitforquote";

export async function submitQuoteService(parameter: SubmitQuoteApiParameter): Promise<ServiceResult<SubmitQuoteFormModel>> {
    try {
        const result = await post<SubmitQuoteFormModel>(`${customUrl}`, parameter.SubmitQuoteForm as SubmitQuoteFormModel);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if ("status" in (error as any) && (error as any).status === 400 && (error as any).errorJson && (error as any).errorJson.message) {
            return {
                successful: false,
                errorMessage: (error as any).errorJson.message,
            };
        }
        throw error;
    }
}